import React from 'react';
import SortableTree from 'react-sortable-tree';
import { connect } from 'react-redux';
import _ from 'lodash';

import { PlusSquare, DeleteSquare } from 'jbc-front/components/icons';

import {
  mapTree,
  getTree,
  getMode,
  insertNode,
  changeNodeValue,
  deleteNode,
  MODES,
  setTree
} from 'src/reducers/clients/groups';
import styles from './GroupsTree.scss';

const MAX_DEPTH = 5;

const GroupsTree = ({ tree, isEditMode, onNodeInsert, onNodeChange, onNodeDelete, onTreeChange }) => {
  const renderTree = mapTree(
    tree,
    ({ node, path }) =>
      node.group
        ? {
            ...node,
            title: isEditMode ? (
              <input
                style={{ width: 'auto' }}
                type="text"
                placeholder="input group name"
                value={node.group.name}
                onChange={({ target: { value } }) => onNodeChange(path, value)}
              />
            ) : (
              node.group.name
            )
          }
        : node
  );
  return (
    <div className="l-overflow-scroll">
      <SortableTree
        treeData={renderTree}
        onChange={currentTree =>
          onTreeChange(
            mapTree(currentTree, ({ node: { title, ...node } }) => ({
              ...node,
              canDelete:
                node.group && node.group.employeesCount === 0 && (!node.children || _.every(node.children, 'canDelete'))
            }))
          )
        }
        maxDepth={MAX_DEPTH}
        isVirtualized={false}
        canDrag={isEditMode}
        generateNodeProps={({ path, node }) => ({
          buttons: [
            isEditMode && path.length < MAX_DEPTH && <PlusSquare size={17} onClick={() => onNodeInsert(path)} />,
            isEditMode && (
              <div className={node.canDelete ? styles.groupDelete : styles.groupDeleteNo}>
                <DeleteSquare size={17} onClick={node.canDelete ? () => onNodeDelete(path) : null} />
                {!node.canDelete && (
                  <div className={styles.groupDeleteNoText}>Cannot remove because it was setted in employee infomation.<br />従業員情報で設定されているので削除できません</div>
                )}
              </div>
            )
          ]
        })}
      />
    </div>
  );
};

const mapStateToProps = state => ({
  tree: getTree(state),
  isEditMode: getMode(state) === MODES.EDIT
});
const mapDispatchToProps = dispatch => ({
  onNodeInsert: path => {
    dispatch(insertNode(path));
  },
  onNodeChange: (path, value) => {
    dispatch(changeNodeValue([path, value]));
  },
  onNodeDelete: path => {
    dispatch(deleteNode(path));
  },
  onTreeChange: tree => {
    dispatch(setTree(tree));
  }
});
export default connect(mapStateToProps, mapDispatchToProps)(GroupsTree);
